export { default } from './TiraAudios';
